/**
 * NumberField - Reusable number input component
 * Uses Tailwind utilities for layout, DaisyUI for input styling
 */
/// <reference lib="dom" />

interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  hint?: string;
}

export const NumberField = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled = false,
  hint,
}: NumberFieldProps) => {
  const handleChange = (e: Event) => {
    const val = parseInt((e.target as HTMLInputElement).value);
    onChange(isNaN(val) ? 0 : val);
  };

  return (
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">{label}</label>
      <input
        type="number"
        class="input input-bordered w-full"
        value={value}
        onInput={handleChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      />
      {hint && <span class="text-xs opacity-60">{hint}</span>}
    </div>
  );
};
